import { ScheduleType } from  "@/interfaces/ScheduledNotifications";
import React, { createContext, useState } from "react";

interface ISchedulePushNotificationContext {
  store: Store;
  setStore: (store: Store) => void;
  clearStore: () => void;
}

interface Store {
  appGuid: string;
  id?: number;
  listId: number;
  notificationType: number;
  scheduleType: ScheduleType;
  scheduledPushTime: string;
  contentId: number;
  message: string;
  reach: number;
}

const storeDefaults: ISchedulePushNotificationContext = {
  store: {
    appGuid: "",
    id: null,
    listId: null,
    notificationType: null,
    scheduleType: null,
    scheduledPushTime: null,
    contentId: null,
    message: "",
    reach: null,
  },
  setStore: () => {},
  clearStore: () => {},
};

export const SchedulePushNotificationContext = createContext(storeDefaults);

export default ({ children }: { children: React.ReactNode }) => {
  const [store, setStore] = useState<Store>(storeDefaults.store);
  const clearStore = () => {
    setStore({
      appGuid: "",
      id: null,
      listId: null,
      notificationType: null,
      contentId:null,
      scheduleType: null,
      scheduledPushTime: "",
      message: "",
      reach: null,
    });
  };

  const context: ISchedulePushNotificationContext = {
    store: store,
    setStore: setStore,
    clearStore: clearStore
  };

  return (
    <SchedulePushNotificationContext.Provider value={context}>
      {children}
    </SchedulePushNotificationContext.Provider>
  );
};
